import React from 'react';
import SimpleButton from '../SimpleButton';
import FadeUp from '../animations/FadeUp';
import { ReactComponent as RightArrow } from '../../assets/svgs/rightArrow.svg';

interface CybersecurityUnderstandingProps {
    id: string;
}

const CybersecurityUnderstanding: React.FC<CybersecurityUnderstandingProps> = ({ id }) => {
    return (
        <div id={id} className="bg-gradient-[113deg] from-custom-blue from-45% to-custom-green to-100% px-4 md:px-0 py-14 md:py-28">
            <FadeUp>
                <div className="container mx-auto flex flex-col gap-10 md:gap-16">
                    <h1 className="mx-auto text-4xl md:text-5xl font-bold text-center max-w-3xl text-white font-jarkarta">
                        Understanding Our Digital Era: <span className='font-normal'>The Significance of Cybersecurity</span>
                    </h1>
                    <div className='flex flex-col md:flex-row justify-center gap-4 md:gap-10 items-top font-inter'>
                        <p className="md:text-xl text-white md:max-w-sm text-left">
                            In an age where the majority of our personal, professional, and societal transactions are digitized, the safety of our online spaces is paramount.
                            Cybersecurity isn’t just about preventing breaches or protecting data – it's about safeguarding our way of life in the digital age.
                        </p>
                        <p className="md:text-xl text-white md:max-w-sm text-left">
                            Every click, every login, every online purchase - it all hinges on robust cybersecurity frameworks.
                            As cyber threats evolve, so must we.
                            With the Heartland Cyber Range, we are one step ahead, championing a safer, more secure digital world for all.
                        </p>
                    </div>
                    <div className='flex justify-center'>
                        <SimpleButton
                            size="large"
                            label="Sign up now"
                            textColor='text-custom-green'
                            bgColor='bg-custom-black'
                            Icon={RightArrow}
                            onClick={() => {
                                const element = document.getElementById("Sign Up");
                                element?.scrollIntoView({ behavior: 'smooth' });
                            }} />
                    </div>
                </div>
            </FadeUp>
        </div>
    );
};

export default CybersecurityUnderstanding;
